import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { UsuarioService } from '../../../pages/usuario/usuario.service';
import { PluginAssinaturaService } from '../../../shared/services/plugin-assinatura.service';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'app-statement-responsibility',
    templateUrl: './statement-responsibility.component.html',
    styleUrls: ['./statement-responsibility.component.css']
})

export class StatementResponsibilityComponent implements OnInit {

    formResp: FormGroup;
    page = 1;
    numPages: Observable<number[]>;
    pdf = { numPages: 1 };
    pdfSrc;

    private bs64pdf;

    constructor(private formBuilder: FormBuilder,
        private authService: AuthenticationService,
        private pluginAssinatura: PluginAssinaturaService,
        private usuarioService: UsuarioService
    ) { }

    ngOnInit() {
        this.criarFormulario();

        this.authService.getUserId().subscribe(idUsuario => {
            this.usuarioService.getBase64TermoResponsabilidade(idUsuario)
                .subscribe(termo => {
                    this.bs64pdf = termo;

                    const byteCharacters = atob(termo);
                    const byteArrays = [];

                    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                        const slice = byteCharacters.slice(offset, offset + 512);

                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }

                    const blob = new Blob(byteArrays, { type: 'application/pdf' });

                    this.pdfSrc = URL.createObjectURL(blob);
                },
                    (error: any) => {
                        console.log('Erro ao buscar o termo de responsabilidade para ser assinado.', error);
                    });
        });

    }

    /**
     * Cria o formulário da página.
     */
    private criarFormulario() {
        this.formResp = this.formBuilder.group({
            aceiteTermo: [false]
        });
    }

    /**
     * Método responsável por realizar a assinatura do termo de responsabilidade.
     */
    public AssinarTermoResponsabilidade() {
        const listabase64 = [btoa(this.bs64pdf)];

        this.authService.Thumbprint.subscribe(thumbprint => {
            this.pluginAssinatura.signDocuments(listabase64, thumbprint)
                .then(resolve => {
                    this.AdicionarAssinaturaTermoResponsabilidade(resolve.Signatures[listabase64[0]]);
                },
                    reject => {
                        console.log('Erro na assinatura do termo de responsabilidade.', reject);
                    });
        });

    }

    /**
     * Método responsável por chamar o serviço que vai adicionar a assinatura do usuário no banco de dados.
     * @param assinaturaDoTermo String que representa a assinatura do termo de responsabilidade realizada pelo usuário.
     */
    private AdicionarAssinaturaTermoResponsabilidade(assinaturaDoTermo: string) {
        this.usuarioService.addAssinaturaTermoResponsabilidade(assinaturaDoTermo)
            .subscribe(assinado => {
                if (assinado) {
                    this.authService.setIsStatementSigned();
                }
            });
    }

    afterLoadComplete(pdf: PDFDocumentProxy) {
        this.pdf = pdf;
        this.numPages = of(Array.from(new Array(pdf.numPages), (val, index) => index + 1));
    }
}
